import { HttpClient } from '@angular/common/http';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var GlobalErrorHandlingService = /** @class */ (function () {
    function GlobalErrorHandlingService(http) {
        this.http = http;
        this.errorReportingUrl = 'reported-errors/';
    }
    GlobalErrorHandlingService.prototype.reportErrorOnServer = function (error) {
        return this.http.post(this.errorReportingUrl, error, { headers: { 'Content-Type': 'application/json' } });
    };
    GlobalErrorHandlingService.ngInjectableDef = i0.defineInjectable({ factory: function GlobalErrorHandlingService_Factory() { return new GlobalErrorHandlingService(i0.inject(i1.HttpClient)); }, token: GlobalErrorHandlingService, providedIn: "root" });
    return GlobalErrorHandlingService;
}());
export { GlobalErrorHandlingService };
